export const GET_LIST_BY_STATE = 'getListByState'
export const GET_LIST = 'getList'
export const SET_LIST = 'setList'
export const SET_LIST_LOADING = 'setListLoading'
export const SET_LIST_RENDER = 'setListRender'
export const SET_PAGE = 'setPage'
export const SET_START_AT = 'setStartAt'
export const SET_START_AFTER = 'setStartAfter'
export const GET = 'get'